module.exports = __webpack_public_path__ + "39d19c35e943ec10032b6f84fd56e7e4.pdf";